export default "2.1.5"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader/dist/cjs.js!./version.txt
// module id = null
// module chunks = 